export default "__VITE_ASSET__BRw51bZv__"